module.exports = __webpack_public_path__ + "img/partner04.bf387c9a.png";